import Home from './components/Home';
import { HeaderColor, FooterColor, SuccessColor, DropzoneColor, ErrorColor, ProcessColor } from './utils/constants';

const App = () => {
  return (
    <div className="App">
      <style>
        {`:root { --Header-color: ${HeaderColor}; }`}
        {`:root { --Footer-color: ${FooterColor}; }`}
        {`:root { --Dropzone-color: ${DropzoneColor}; }`}
        {`:root { --Success-color: ${SuccessColor}; }`}
        {`:root { --Error-color: ${ErrorColor}; }`}
        {`:root { --Process-color: ${ProcessColor}; }`}
      </style>
      <Home></Home>
    </div>
  );
}

export default App;
